import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=730f236c&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=730f236c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730f236c",
  null
  
)

export default component.exports